<template>
  <div>
        <h1>Concesiones</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar concesión"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getConcesionByConcesionario"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          align="right"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getConcesionByConcesionario.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
import gql from 'graphql-tag'
export default {
  data() {
    return {
      fields: [
        // { key: 'id', label: 'Id ', sortable: true, sortDirection: 'desc' },
        { key: 'concesionNumber', label: 'Número de Concesión', sortable: true, sortDirection: 'desc' },
        { key: 'concesionario.name', label: 'Concesionario' },
        { key: 'concesionario.rfc', label: 'RFC' },
        { key: 'vehicle.brand', label: 'Marca Vehículo' },
        { key: 'vehicle.model', label: 'Modelo Vehículo' },
        { key: 'vehicle.serialNumber', label: 'Número de Serie' },
        { key: 'vehicle.licensePlate', label: 'Número de placa del vehículo' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idConcesionAction: null,
      dataLoad: -1,
    }
  },
  apollo: {
    getConcesionByConcesionario: {
      query: gql`query getConcesionByConcesionario ($id: Int!) {
          getConcesionByConcesionario (id: $id){
            id
            concesionNumber
            concesionario{
            name
            rfc
            }
            vehicle{
            id
            brand
            serialNumber
            model
            licensePlate
            }
            active
          }
        }`,
      context: headers(),
      variables () {
        return {
          id: this.dataLoad,
        }
      },
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getConcesionByConcesionario) {
          this.totalRows = data.getConcesionByConcesionario.length
        }
      },
    },
  },
  created: function () {
    // `this` hace referencia a la instancia vm
    this.dataLoad = parseInt(this.getFranchisee)
    // console.log(this.getFranchisee)
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  computed: {
    getFranchisee() {
      return this.$store.state.user.franchisee
    },
  },
}
</script>
<style>
</style>
